import type { CatalogTree } from '../types';

export const settings = {
  tabs: {
    label: 'Ayar bölümleri',
    business: 'İşletme',
    users: 'Kullanıcılar',
    notifications: 'Bildirimler',
    billing: 'Plan ve ödeme',
    account: 'Hesap',
  },
  save: 'Kaydet',
  business: {
    profile: 'İşletme',
    legal: 'Yasal bilgiler',
    fields: {
      business_name: 'İşletme adı',
      contact_name: 'Yetkili adı',
      phone: 'Telefon',
      email: 'E-posta',
      legal_name: 'Ünvan',
      tax_id: 'Vergi numarası',
      tax_office: 'Vergi dairesi',
    },
    sector: {
      label: 'Sektör',
      gold: 'Altın',
      jewelry: 'Mücevher',
      silver: 'Gümüş',
    },
    address: {
      label: 'Mağaza adresi',
      line1: 'Adres satırı 1',
      line2: 'Adres satırı 2',
      district: 'İlçe',
      city: 'İl',
      postal_code: 'Posta kodu',
    },
    legalNote: 'Bu bilgiler faturalarınızda kullanılır.',
    invoiceError:
      'Bir faturanız hatalı alıcı bilgisi nedeniyle kesilemedi; bilgileri düzeltin, ESNAF AI ekibi faturayı yeniden düzenler.',
  },
  users: {
    seats: 'Koltuk',
    columns: {
      name: 'Ad',
      email: 'E-posta',
      role: 'Rol',
      status: 'Durum',
      lastLogin: 'Son giriş',
      invitedBy: 'Davet eden',
      twoStep: 'İki adımlı',
    },
    status: {
      invited: 'Davetli',
      active: 'Aktif',
      disabled: 'Devre dışı',
    },
    actions: {
      role: 'Rolü değiştir',
      revoke: 'Daveti iptal et',
      reinvite: 'Yeniden davet et',
      remove: 'Kaldır',
    },
    revokeDescription: 'Davet geçersiz olur ve koltuk boşalır.',
    remove: {
      title: 'Kullanıcıyı kaldır',
      description: '{name} panele giremez; oturumları kapatılır. Konuşma ve notlardaki adı kalır.',
    },
    seatsFull:
      'Planınızın koltukları dolu ({limit}). Bir kullanıcıyı kaldırın veya planınızı yükseltin.',
    invite: {
      title: 'Kullanıcı davet et',
      email: 'E-posta',
      role: 'Rol',
      roleHint:
        'İşletme sahibi: ayarlar ve ödeme dahil her şey. Personel: gelen kutusu, müşteriler, ürünler, satışlar.',
      note: 'Davet bağlantısı 7 gün geçerlidir.',
      submit: 'Davet gönder',
    },
  },
  notifications: {
    table: 'Olaylar',
    event: 'Olay',
    push: 'Push',
    email: 'E-posta',
    boxLabel: '{title}: {channel}',
    inApp: 'Uygulama içi bildirimler her zaman açıktır.',
    types: {
      handoff_created: 'Personel bekleyen konuşma',
      conversation_assigned: 'Size atanan konuşma',
      waiting_too_long: 'Çok uzun bekleyen konuşma',
      window_closing: 'Yanıt süresi dolmak üzere',
      message_failed: 'Mesaj gönderilemedi',
      channel_problem: 'Kanal sorunu',
      store_problem: 'Mağaza sorunu',
      payment_failed: 'Ödeme alınamadı',
      card_expiring: 'Kartın süresi doluyor',
      usage_80: 'AI kullanımı %80',
      usage_100: 'AI kullanım hakkı doldu',
    },
  },
  billing: {
    interval: {
      monthly: 'Aylık',
      annual: 'Yıllık',
    },
    intervalLower: {
      monthly: 'aylık',
      annual: 'yıllık',
    },
    checkout: 'Ödemeye geç',
    checkoutOff: 'Abonelik işlemleri ESNAF AI ekibi tarafından yapılır.',
    subscription: {
      title: 'Abonelik',
      period: '{start} – {end}',
      nextCharge: 'Sonraki ödeme: {date} · {amount}',
      trialEnds: 'Deneme {date} tarihinde biter',
      pendingChange: '{plan}, {interval} {date} tarihinde başlar',
      cancelAtPeriodEnd: 'Dönem sonunda iptal edilecek',
      pastDue: 'Ödeme alınamadı; {date} tarihinde yeniden denenecek',
      suspended: 'Askıda: asistan yanıt vermiyor. Ödeme yapınca yeniden başlar.',
    },
    card: {
      title: 'Kart',
      digits: '•••• {last4}',
      update: 'Kartı güncelle',
    },
    usage: {
      title: 'Kullanım',
      units: 'Bu dönem kullanılan birim',
    },
    profile: {
      title: 'Fatura bilgileri',
      edit: 'Düzenle',
      legal_name: 'Ünvan',
      tax_id: 'Vergi numarası',
      tax_office: 'Vergi dairesi',
      address: 'Adres',
      eFatura: 'e-Fatura mükellefiyim',
      invoiceEmail: 'Fatura e-postası',
    },
    invoices: {
      title: 'Faturalar',
      number: 'Numara',
      kind: 'Tür',
      kinds: {
        e_arsiv: 'e-Arşiv',
        e_fatura: 'e-Fatura',
      },
      period: 'Dönem',
      gross: 'Tutar',
      status: 'Durum',
      issuedAt: 'Düzenlenme',
      pdf: 'PDF',
      empty: 'Henüz fatura yok.',
    },
    change: {
      title: 'Plan değişikliği',
      to: {
        annual: 'Yıllığa geç',
        monthly: 'Aylığa geç',
      },
      cancel: 'Aboneliği iptal et',
      intervalDescription:
        'Yeni dönem {plan}, {interval} olarak {date} tarihinde başlar; o güne kadar mevcut planınız sürer. Deneme sürecindeyseniz deneme bitince başlar.',
      cancelDescription:
        'Aboneliğiniz {date} tarihinde sona erer; o güne kadar kullanmaya devam edersiniz. Sonrasında asistan durur ve panel salt okunur kalır.',
      saved: 'Dönem değişikliği kaydedildi.',
    },
    result: {
      cardUpdated: 'Kart güncellendi.',
      started: 'Aboneliğiniz başladı.',
      declined: 'Kart reddedildi.',
    },
  },
  account: {
    title: 'Hesabı kapat',
    warning:
      'Hesap kapatılınca işletmenizin tüm verileri silinir: konuşmalar, müşteriler, ürün kopyanız, içerikler ve ayarlar. Faturalar yasal süre boyunca saklanır.',
    password: 'Şifre',
    word: 'Onaylamak için {word} yazın',
    wrongPassword: 'Şifre hatalı.',
    closed: 'Hesabınız kapatıldı.',
  },
} as const satisfies CatalogTree;
